export default "<funz-chat [id]=\"id\" [ownerId]=\"ownerId\" [params]=\"params\" (onBack)=\"dismiss()\"></funz-chat>";